<template>
  <div id="standard">
    <sport
      v-for="sport in sports"
      :key="sport.id"
      :sport="sport"
    />
  </div>
</template>

<script>
import { each, orderBy, isEmpty } from 'lodash';
import Sport from './Sport.vue';

export default {
  name: 'Standard',
  components: { Sport },
  data() {
    return {
      rowCountMax: 19,
    };
  },
  computed: {
    sports() {
      let rowCount = 0;

      const sportsToDisplay = [];
      let loop = true;

      const matches = [];
      each(this.$store.getters.activeSports, (sport) => {
        const sportMatches = this.$store.getters.getSportMatches(sport.id);
        each(sportMatches, (sportMatch) => {
          matches.push(Object.assign({}, sportMatch, { positionSport: sport.position }));
        });
      });

      let positionOrderedMatches = orderBy(matches, ['position', 'positionSport', 'positionCategory', 'startAt', 'positionTournament'], ['asc', 'asc', 'asc', 'asc', 'asc']);

      if (positionOrderedMatches.length > this.rowCountMax) {
        positionOrderedMatches = positionOrderedMatches.slice(0, this.rowCountMax);
      }

      const sports = [];
      const sportMatchIds = {};
      let totalRows = 0;

      each(positionOrderedMatches, (match) => {
        totalRows += 1;

        if (sports.indexOf(match.idSport) === -1) {
          if (totalRows === this.rowCountMax) return false;

          sports.push(match.idSport);
          sportMatchIds[match.idSport] = [];
          totalRows += 1;
        }

        sportMatchIds[match.idSport].push(match.id);

        if (totalRows === this.rowCountMax) return false;
      });

      each(this.$store.getters.activeSports, (sport) => {
        if (!loop || !sportMatchIds[sport.id]) return;

        const matchIds = sportMatchIds[sport.id];

        if (!isEmpty(matchIds)) sportsToDisplay.push(sport);

        // Count how many matches needs to be spliced from last sport
        rowCount += 1; // Sport header
        rowCount += matchIds.length; // Number of matches
        if (rowCount >= this.rowCountMax - 1) {
          if (this.rowCountMax - rowCount < 0) {
            matchIds.splice(this.rowCountMax - rowCount);
          }
          this.$store.dispatch('setSportMatches', { idSport: sport.id, matchIds });
          loop = false;
        } else {
          this.$store.dispatch('setSportMatches', { idSport: sport.id, matchIds });
        }
      });

      return sportsToDisplay;
    },
  },
};
</script>
